import { useEffect, useState } from "react";
import { Link } from 'react-router-dom'; 
const ITEMS_PER_PAGE = 16;

export default function ArtistList() {
  const [artists, setArtists] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const wpUrl = process.env.REACT_APP_WP_URL;
  useEffect(() => {
    const fetchArtists = async () => {
      try {
        const response = await fetch(
          `${wpUrl}wp-json/wp/v2/posts?status=publish&per_page=100&_embed`
        );
        const data = await response.json();

        let allArtists = [];

        data.forEach((post) => {
          const artistRaw = post.artist || post.acf?.artist || "";
          const parsed = artistRaw
            .split(",")
            .map((name) => name.trim())
            .filter(Boolean);
          allArtists = [...allArtists, ...parsed];
        });

        const uniqueArtists = [...new Set(allArtists)];
        setArtists(uniqueArtists);
      } catch (error) {
        console.error("Error fetching artists:", error);
      }
    };

    fetchArtists();
  }, []);

  const totalPages = Math.ceil(artists.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentArtists = artists.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <section className="gallery-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Artists in Events</span>
          </div>
          <h2 className="section-title__title">Artists</h2>
        </div>

        <div className="schedule-three__top flex justify-center">
          <div className="schedule-three__time-box flex flex-wrap justify-center gap-4">
            {currentArtists.map((artist, index) => (
              <div key={index} className="schedule-three__time-info-box">
                <div className="schedule-three__time-info-box-content text-center">
                  <Link to={`/event?artist=${artist}`}><h4 className="artist-link">{artist}</h4></Link>
                  
                </div>
              </div>
            ))}
          </div>
        </div>
                 
                               
                              
        {/* Pagination Controls */}
         
                     
                    <div  className="pagination">
                        <button
                          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                          disabled={currentPage === 1}
                          
                        >
                          Prev
                        </button>

                        {[...Array(totalPages)].map((_, idx) => (
                          <button 
                            key={idx}
                            onClick={() => setCurrentPage(idx + 1)}
                            className={currentPage === idx + 1 ? 'active' : ''}
                          >
                            {idx + 1}
                          </button>
                        ))}

                        <button
                          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                          disabled={currentPage === totalPages}
                          
                        >
                          Next
                        </button>
                      </div>

                    </div>
                     
    </section>
  );
}
